
var url_domain = window.location.host;
var config_url = '';
if (url_domain == 'localhost:8080') {
config_url = 'https://apitest.ccdfvf.com/api/1.0'; 
} else if (url_domain == 'test.ccdfvf.com') {
  config_url = 'https://apitest.ccdfvf.com/api/1.0'; 

}
 else if (url_domain == 'ccdfvf.com') {
  config_url = 'https://api.ccdfvf.com/api/1.0'; 
}

console.log('Backend Conected: ' + config_url)
export const apiPath = config_url;


